<template>
  <Message
    v-if="hasActiveDocumentRequests && numCompletedSteps === totalNumberOfSteps"
    severity="warn"
    :closable="false"
  >
    <p v-if="hasBankStatementRequest">
      To receive accurate pricing, please ensure you have
      <router-link
        :to="{
          name: RouteNames.DOCUMENTS.INDEX,
        }"
        >uploaded</router-link
      >
      the most recent 6 months worth of bank statements for your connected bank
      account.
    </p>
    <p v-else>
      We require additional documents, please
      <router-link
        :to="{
          name: RouteNames.DOCUMENTS.INDEX,
        }"
        >upload required document(s)</router-link
      >
      to avoid funding delays.
    </p>
  </Message>
</template>
<script>
import { mapGetters } from 'vuex';
import { RouteNames } from '@/data/routes';
import Message from 'primevue/message';

export default {
  data() {
    return {
      RouteNames,
    };
  },
  components: {
    Message,
  },
  computed: {
    ...mapGetters([
      'hasActiveDocumentRequests',
      'activeDocumentRequests',
      'businessProfileSteps',
    ]),
    numCompletedSteps() {
      return Object.values(this.businessProfileSteps).filter(
        (step) => step.isComplete,
      ).length;
    },
    totalNumberOfSteps() {
      return Object.keys(this.businessProfileSteps).length;
    },
    hasBankStatementRequest() {
      return this.activeDocumentRequests.some(
        (request) => request.type === 'bank_statements',
      );
    },
  },
};
</script>
